import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@6.0.11@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ib-a-minus",
  "use": "icon-ib-a-minus-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ib-a-minus\">\n    <path d=\"M469.333333 170.666667h85.333334v682.666666h-85.333334z\" p-id=\"6470\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol